import { lazy } from "react";
import { privileges } from "./constants/privileges";

import { WordPressPost, WordPressPostTest } from "./shared/components/Wordpress/WordPressPost.tsx";
import { WordPressPostList } from "./shared/components/Wordpress/WordPressPostList";
import ProviderTermsList from "./views/ProviderAgreement/ProviderTermsList";
import WordPressArchiveList from "./shared/components/Wordpress/WordPressArchiveList";
import WordpressArchivedPost from "./shared/components/Wordpress/WordpressArchivedPost";
const BidOnProjects = lazy(() => import("./views/Bids/BidOnProjects"));
const BidDetails = lazy(() => import("./views/Bids"));
const MyBids = lazy(() => import("./views/Bids/MyBids"));
const B2BSolutions = lazy(() => import("./views/Website/B2BSolutions"));
const LandingPage = lazy(() => import("./views/Website/LandingPage"));
const AboutUs = lazy(() => import("./views/Website/AboutUs"));
const Sustainability = lazy(() => import("./views/Website/Sustainability"));
const Auth = lazy(() => import("./views/Auth"));
const TaskDetails = lazy(() => import("./views/Tasks/TaskDetails"));
const GetTasksPage = lazy(() => import("./views/Tasks/GetTasksPage"));
const AccountPage = lazy(() => import("./views/AccountPage"));
const ConfirmationPage = lazy(() => import("./views/ConfirmationPage"));
const MyTasksPage = lazy(() => import("./views/MyTasksPage"));
const BookingPage = lazy(() => import("./views/BookingPage"));
const OrdersPage = lazy(() => import("./views/MyOrders/OrdersPage"));
const CustomerDiversion = lazy(() => import("./views/Dashboards/Diversion"));
const CustomerDiversionV2 = lazy(() => import("./views/Dashboards/DiversionV2"));
const BookingDetails = lazy(() => import("./views/MyOrders/OrderDetailsPage"));
const ReviewOrder = lazy(() => import("./views/MyOrders/OrderReviewPage"));
const CompleteTask = lazy(() => import("./views/CompleteTask"));
const CompleteTaskV2 = lazy(() => import("./views/CompleteTask/CompleteTaskV2"));
const VehicleInfo = lazy(() => import("./views/VehicleInfo"));
const AlertsPage = lazy(() => import("./views/AlertsPage"));
const CustomerAlertSettings = lazy(() => import("./views/CustomerAlertSettings"));
const Company = lazy(() => import("./views/AccountPage/Company"));
const IntegrationsPage = lazy(() => import("./views/IntegrationsPage"));
const DriversLicense = lazy(() => import("./views/DriversLicense"));
const WatchVideo = lazy(() => import("./views/WatchVideo"));
const ProfilePicture = lazy(() => import("./views/ProfilePicture"));
const CompleteProfile = lazy(() => import("./views/CompleteProfile"));
const Page404 = lazy(() => import("@shared/components/Page404"));
const QuotePage = lazy(() => import("./views/QuotePage"));
const ProfilePage = lazy(() => import("./views/ProfilePage"));
const BubbleRedirect = lazy(() => import("./views/BubbleRedirect"));
const ClientIntake = lazy(() => import("./views/ClientIntake"));
const ProviderAgreement = lazy(() => import("./views/ProviderAgreement"));
const SanitizerDisposal = lazy(() => import("./views/DisposalPage/SanitizerDisposal"));
const PalletDisposal = lazy(() => import("./views/DisposalPage/PalletDisposal"));
const SolarPanelDisposal = lazy(() => import("./views/DisposalPage/SolarPanelDisposal"));
const HazardousWasteDisposal = lazy(() => import("./views/DisposalPage/HazardousWasteDisposal"));
const FireDebrisDisposal = lazy(() => import("./views/DisposalPage/FireDebrisDisposal"));
const AIDisposal = lazy(() => import("./views/DisposalPage/AIDisposal"));
const BeverageDisposal = lazy(() => import("./views/DisposalPage/BeverageDisposal"));
const AlcoholDisposal = lazy(() => import("./views/DisposalPage/AlcoholDisposal"));
const CompostDisposal = lazy(() => import("./views/DisposalPage/CompostDisposal"));
const UpdaterDisposal = lazy(() => import("./views/DisposalPage/UpdaterDisposal"));
const WarriorETA = lazy(() => import("./views/Tasks/WarriorETA"));
const ProviderSurvey = lazy(() => import("./views/ProviderSurvey"));
// static pages
const ProviderPortal = lazy(() => import("./views/Website/ProviderPortal"));
const PricingGuide = lazy(() => import("./views/PricingGuide"));
const Why = lazy(() => import("./pages/Why"));
const Help = lazy(() => import("./pages/Help"));
const HowItWorks = lazy(() => import("./pages/HowItWorks"));
const CorporateClient = lazy(() => import("./pages/CorporateClient"));
const PreferredPartnerAgreement = lazy(() => import("./pages/PreferredPartnerAgreement"));
const CaseStudies = lazy(() => import("./pages/CaseStudies"));
const Testimonials = lazy(() => import("./pages/Testimonials"));
const Covid19 = lazy(() => import("./pages/Covid19"));
const Pricing = lazy(() => import("./pages/Pricing"));
const CaseStudy = lazy(() => import("./pages/CaseStudy"));
const CleaningReport = lazy(() => import("./pages/CleaningReport"));
const ProviderAgreementV2 = lazy(() => import("./pages/ProviderAgreementV2"));
const ProviderResource = lazy(() => import("./pages/ProviderResource"));
const TieredServicePricing = lazy(() => import("./pages/TieredServicePricing"));
const AmazonCaseStudy = lazy(() => import("./pages/AmazonCaseStudy"));
const SaresRegis = lazy(() => import("./pages/SaresRegis"));
const ArchivedDocuments = lazy(() => import("./pages/Archives"));

export const wordpressGroups = [
  { path: "/materials/:id", name: "Materials & Waste Streams", component: WordPressPost, bypass: true },
  { path: "/recycling/:id", name: "Recycling", component: WordPressPost, bypass: true },
  { path: "/business/:id", name: "B2b Solutions", component: WordPressPost, bypass: true },
  { path: "/case-studies/:id", name: "Case Study", component: WordPressPost, bypass: true },
  { path: "/blog/:id", name: "Blog Post", component: WordPressPost, bypass: true },
];
const wordpressDirectories = [
  // { path: "/sustainability", exact: true, name: "Sustainability", component: WordPressDirectory },
  // { path: "/b2b-solutions", exact: true, name: "B2B Solutions", component: WordPressDirectory },
];

const routes = [
  {
    path: "/junk_removal",
    name: "Landing Page",
    component: LandingPage,
    privilege: privileges.CREATE_BOOKING.name,
    title: "Junk Removal - Waste Management Services | Dimension",
  },
  {
    path: "/cardboard_removal",
    name: "Landing Page",
    component: LandingPage,
    privilege: privileges.CREATE_BOOKING.name,
    title: "Cardboard Removal - Waste Management Services | Dimension",
  },
  {
    path: "/dumpster_rental",
    name: "Landing Page",
    component: LandingPage,
    privilege: privileges.CREATE_BOOKING.name,
    title: "Dumpster Rental - Waste Management Services | Dimension",
  },
  {
    path: "/booking",
    name: "Booking Page",
    component: BookingPage,
    privilege: privileges.CREATE_BOOKING.name,
    requiresStripe: true,
    title: "Book a Service - Waste Management Services | Dimension",
  },
  { path: "/review/:id", name: "Review Order", component: ReviewOrder, privilege: privileges.VIEW_CUSTOMER_BOOKING_PAGE.name },
  { path: "/bookings/:id", name: "Order Details", component: BookingDetails, privilege: privileges.VIEW_CUSTOMER_BOOKING_PAGE.name },
  { path: "/bookings", name: "My Orders", component: OrdersPage, privilege: privileges.VIEW_MY_BOOKINGS_PAGE.name },
  { path: "/dashboard-legacy", name: "Diversion", component: CustomerDiversion, privilege: privileges.VIEW_MY_BOOKINGS_PAGE.name },
  { path: "/dashboard", name: "Diversion", component: CustomerDiversionV2, privilege: privileges.VIEW_MY_BOOKINGS_PAGE.name },
  { path: "/confirmation/:id", name: "Bubble Confirmation Page", component: BubbleRedirect },
  { path: "/confirmation", name: "Booking Confirmation Page", component: ConfirmationPage },
  { path: "/auth", name: "Sign In Page", component: Auth },
  { path: "/auth/reset_pw", name: "Reset Password" }, // only for showing the proper name on breadcrumb
  { path: "/auth/signup_with_google", name: "Sign up with Google" }, // only for showing the proper name on breadcrumb
  {
    path: "/provider_portal",
    name: "Provider Portal",
    component: ProviderPortal,
    title: "Providers - Start Growing Your Business Today | Dimension",
  },
  { path: "/get_tasks", name: "Tasks Available Page", component: GetTasksPage, privilege: privileges.VIEW_GET_TASKS_PAGE.name },
  { path: "/tasks", name: "Tasks Assigned Page", component: MyTasksPage, privilege: privileges.VIEW_GET_TASKS_PAGE.name },
  { path: "/task_details/:id", name: "Task Details", component: TaskDetails, requiresStripe: true },
  { path: "/bids", name: "Bids Offered Page", component: MyBids },
  { path: "/get_bids", name: "Bid On Projects Page", component: BidOnProjects },
  { path: "/bid_details/:id", name: "Task Details", component: BidDetails, requiresStripe: true },
  { path: "/complete_details/:id", name: "Complete Task", component: CompleteTask, privilege: privileges.VIEW_GET_TASKS_PAGE.name },
  { path: "/complete_details_v2/:id", name: "Complete Task", component: CompleteTaskV2, privilege: privileges.VIEW_GET_TASKS_PAGE.name },
  { path: "/eta/:id", name: "Warrior ETA", component: WarriorETA },
  { path: "/quote_details/:id", name: "Quote Details", component: QuotePage },
  { path: "/account", name: "Account", component: AccountPage, privilege: privileges.VIEW_ACCOUNT_PROFILE.name, requiresStripe: true },
  { path: "/integrations", name: "Integrations", component: IntegrationsPage, privilege: privileges.VIEW_INTEGRATIONS_PAGE.name },
  { path: "/company", name: "Company", component: Company, privilege: privileges.VIEW_COMPANY_SETTINGS.name },
  { path: "/alerts", name: "Alerts", component: AlertsPage, privilege: privileges.VIEW_ACCOUNT_SETTINGS.name },
  { path: "/drivers_license", name: "Drivers License", component: DriversLicense, privilege: privileges.VIEW_ACCOUNT_SETTINGS.name },
  { path: "/upload_picture", name: "Upload Picture", component: ProfilePicture, privilege: privileges.VIEW_ACCOUNT_SETTINGS.name },
  { path: "/watch_video", name: "Watch Videos", component: WatchVideo, privilege: privileges.VIEW_ACCOUNT_SETTINGS.name },
  { path: "/vehicle_info", name: "VehicleInfo", component: VehicleInfo, privilege: privileges.VIEW_ACCOUNT_SETTINGS.name },
  { path: "/complete_profile", name: "CompleteProfile", component: CompleteProfile, privilege: privileges.VIEW_ACCOUNT_SETTINGS.name },
  { path: "/alerts_sms_email", name: "CustomerAlertSettings", component: CustomerAlertSettings, privilege: privileges.VIEW_ACCOUNT_SETTINGS.name },
  { path: "/profile_details/:id", name: "Profile Details", component: ProfilePage, authRequired: true },
  { path: "/provider_agreement", name: "Provider Agreement", component: ProviderAgreement, privilege: privileges.VIEW_GET_TASKS_PAGE.name },
  { path: "/guest/:id", name: "Bubble Guest", component: BubbleRedirect },
  { path: "/pricing_guide", name: "Pricing Guide", component: PricingGuide },
  { path: "/newclientintake", name: "New Client Intake", component: ClientIntake, requiresStripe: true },
  {
    path: "/b2b-solutions",
    name: "B2B Solutions",
    component: B2BSolutions,
    title: "Junk Removal for Businesses - Weekly Dumpster Rentals | Dimension Waste Management",
  },
  {
    path: "/about_us",
    name: "About Us",
    component: AboutUs,
    title: "Fast, Reliable and Sustainable Waste Removal Services - Diversion Focused | Dimension Waste Management",
  },
  {
    path: "/sustainability",
    name: "Sustainability Hub",
    component: Sustainability,
    title: "Sustainability and Waste Diversion - Waste Removal Services | Dimension Waste Management",
  },
  {
    path: "/",
    exact: true,
    name: "Home",
    component: LandingPage,
    title: "Waste Removal, Mattress Removal and Dumpster Rental - Same Day Junk Removal | Dimension Waste Management",
  },

  // static pages

  { path: "/why", name: "Why Dimension", component: Why },
  { path: "/how-it-works", name: "How It Works", component: HowItWorks },
  { path: "/help", name: "Help", component: Help },
  { path: "/faq", name: "Faq", component: WordPressPost },
  {
    path: "/corporate_client",
    name: "Corporate Client",
    component: CorporateClient,
    title: "Corporate Client - Business Junk Removal Services | Dimension Waste Management",
  },
  {
    path: "/case-studies",
    exact: true,
    name: "Case Studies",
    component: CaseStudies,
    title: "Case Studies - Waste Management Services | Dimension Waste Management",
  },
  { path: "/testimonials", name: "Testimonials", component: Testimonials },
  { path: "/covid-19", name: "Covid 19", component: Covid19 },
  { path: "/pricing", name: "Pricing", component: Pricing },
  { path: "/case-study/:id", name: "Case Study", component: CaseStudy },
  { path: "/cleaning_report/:id", name: "Cleaning Report", component: CleaningReport },
  { path: "/provideragreementv2", name: "Provider Agreement", component: ProviderAgreementV2 },
  { path: "/provider-policy-updates", name: "Provider Policy Updates", component: ProviderTermsList, exact: true },
  { path: "/providerresource", name: "Provider Resource", component: ProviderResource },
  { path: "/tieredservicepricing", name: "Tiered Service Pricing", component: TieredServicePricing },
  {
    path: "/amazon_case_study",
    name: "Amazon Case Study",
    component: AmazonCaseStudy,
    title: "Amazon - Business Junk Removal Services | Dimension Waste Management",
  },
  {
    path: "/sares_regis",
    name: "Sares Regis",
    component: SaresRegis,
    title: "Sares Regis - Business Junk Removal Services | Dimension Waste Management",
  },
  { path: "/staging/:id", name: "Test Page", component: WordPressPostTest },
  {
    path: "/blog",
    exact: true,
    name: "Blog",
    component: WordPressPostList,
    title: "Blog - Sustainability and Waste Management | Dimension Waste Management",
  },
  { path: "/slack", name: "Slack Integration", component: WordPressPost },
  {
    path: "/instacart-landing",
    name: "Instacart",
    component: WordPressPost,
    title: "Instacart - Business Waste Removal Services | Dimension Waste Management",
  },
  {
    path: "/in-the-news",
    name: "In the news",
    component: WordPressPost,
    title: "In The News - Sustainable Waste Management Services | Dimension Waste Management",
  },
  {
    path: "/freefirsttrial",
    name: "Free First Trial",
    component: WordPressPost,
    title: "Save 10% or more of your waste bill - First experience free | Dimension Waste Management",
  },
  {
    path: "/freefirsttrial_success",
    name: "Thank you for submitting",
    component: WordPressPost,
    title: "Save 10% or more of your waste bill - First experience free | Dimension Waste Management",
  },
  {
    path: "/sanitizer-disposal",
    name: "Sanitizer Disposal Service",
    component: SanitizerDisposal,
    title: "Sanitizer Disposal Service | Dimension Waste Management",
  },
  {
    path: "/hand-sanitizer-disposal",
    name: "Sanitizer Disposal Service",
    component: SanitizerDisposal,
    title: "Sanitizer Disposal Service | Dimension Waste Management",
  },
  {
    path: "/pallet-disposal",
    name: "Pallet Disposal Service",
    component: PalletDisposal,
    title: "Pallet Disposal Service | Dimension Waste Management",
  },
  {
    path: "/solar-panel-disposal",
    name: "Solar Panel Disposal Service",
    component: SolarPanelDisposal,
    title: "Solar Panel Disposal Service | Dimension Waste Management",
  },
  {
    path: "/solar-panel-sell",
    name: "Sell Your Solar Panels",
    component: SolarPanelDisposal,
    title: "Solar Panel Services | Dimension Waste Management",
  },
  {
    path: "/commercial-solar-panel-uninstallation-and-disposal",
    name: "Commercial Solar Panel Uninstallation and Disposal Service",
    component: SolarPanelDisposal,
    title: "Commercial Solar Panel Uninstallation and Disposal Service | Dimension Waste Management",
  },
  {
    path: "/hazardous-waste-disposal",
    name: "Hazardous Waste Disposal Service",
    component: HazardousWasteDisposal,
    title: "Hazardous Waste Disposal Service | Dimension Waste Management",
  },
  {
    path: "/fire-debris-removal",
    name: "Fire Debris Removal Service",
    component: FireDebrisDisposal,
    title: "Fire Debris Removal Service | Dimension Waste Management",
  },
  {
    path: "/oil-recycling",
    name: "Oil Recycling Services",
    component: HazardousWasteDisposal,
    title: "Oil Recycling Service | Dimension Waste Management",
  },
  {
    path: "/beverage-disposal",
    name: "Beverage Disposal Service",
    component: BeverageDisposal,
    title: "Beverage Disposal Services | Dimension Waste Management",
  },
  {
    path: "/alcohol-disposal",
    name: "Alcohol Disposal Service",
    component: AlcoholDisposal,
    title: "Alcohol Disposal Services | Dimension Waste Management",
  },
  {
    path: "/compost-disposal-austin",
    name: "Austin Composting Service",
    component: CompostDisposal,
    title: "Austin Composting Service | Dimension Waste Management",
  },
  {
    path: "/compost-disposal",
    name: "Composting Service",
    component: CompostDisposal,
    title: "Composting Service | Dimension Waste Management",
  },
  {
    path: "/junk-disposal",
    name: "Book Now",
    component: AIDisposal,
    privilege: privileges.CREATE_BOOKING.name,
    title: "Book Now | Dimension Waste Management",
  },
  {
    path: "/updater-disposal",
    name: "Book Now",
    component: UpdaterDisposal,
    privilege: privileges.CREATE_BOOKING.name,
    title: "Disposal Services for Moves | Dimension and Updater",
  },
  { path: "/archives", name: "Archives", component: ArchivedDocuments, exact: true },
  { path: "/terms", name: "Terms", component: WordPressPost, exact: true },
  { path: "/preferredpartneragreement", name: "Preferred Partner Agreement", component: PreferredPartnerAgreement },
  { path: "/corporateserviceagreement", name: "Corporate Service Agreement", component: WordPressPost, exact: true },
  { path: "/privacy-policy", name: "Privacy Policy", component: WordPressPost, exact: true },
  { path: "/provider-agreement", name: "Provider Agreement", component: WordPressPost, exact: true },
  { path: "/service-provider-policy", name: "Service Provider Policy", component: WordPressPost, exact: true },
  { path: "/:slug/archive", name: "Policy Archive", component: WordPressArchiveList, exact: true },
  { path: "/:slug/archive/:id", name: "Policy Archive", component: WordpressArchivedPost },
  ...wordpressGroups,
  ...wordpressDirectories,
  { path: "/provider-survey", name: "Provider Survey", component: ProviderSurvey },
  // 404
  { path: "*", name: "404 Not Found", component: Page404 },
];

export default routes;
